import DateControl from './DateControl'
export default DateControl


// WEBPACK FOOTER //
// ./src/modules/DateControl/index.js